import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../../../components/Card';

RedirectChoice.propTypes = {
  title: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};

export default function RedirectChoice(props) {
  const {
    title,
    onClick
  } = props;

  return (
    <Card
      className={classNames(
        'p-6 cursor-pointer hover:bg-cs-orange-50',
        'border border-cs-gray-300 m-px',
        'flex flex-col sm:flex-row items-start sm:items-center gap-4'
      )}
      onClick={onClick}
    >
      <div className="flex flex-row items-start sm:items-center gap-4">
        {props.icon && (
          <props.icon className="w-8 h-8 text-cs-yellow-500" />
        )}
        <div className="text-lg flex-1 text-cs-gray-700 font-semiboldx">
          {title}
        </div>
      </div>
    </Card>
  );
};
